export default __webpack_public_path__ + "static/sga_solutions-d355d0f4a85d83c9f02f6171429b111e.png";